import { FieldConfig } from "../../../components/form/FieldRenderer";

export const licenseCount: FieldConfig[] = [
  {
    name: "no_of_licenses",
    label: "No. of License",
    type: "text",
    required: true,
  },
];

export const paymentTop: FieldConfig[] = [
  {
    name: "total_paid_amount",
    label: "Total amount ($)",
    type: "text",
    required: true,
  },
  {
    name: "discount",
    label: "Discount(%)",
    type: "text",
    belowNote: ({ watch }) => {
      const amt = parseFloat(watch("total_paid_amount") || "0");
      const discRaw = parseFloat(watch("discount") || "0");
      const disc = isNaN(discRaw) ? 0 : Math.min(discRaw, 100);
      const val = isNaN(amt) ? "0.00" : (amt - (amt * disc) / 100).toFixed(2);
      return (
        <>
          After discount: <span className="font-bold">${val}</span>
        </>
      );
    },
  },
  {
    name: "payment_mode",
    label: "Payment Mode",
    type: "select",
    required: true,
    options: [
      { label: "-- Choose Payment method--", value: "" },
      { label: "By Cheque", value: "by-cheque" },
      { label: "Cash", value: "cash" },
    ],
  },
  { name: "transaction_ref", label: "Transaction ID", type: "text" },
];

export const paymentDates: FieldConfig[] = [
  {
    name: "date_of_payment",
    label: "Date of payment",
    type: "date",
    required: true,
    gridSpan: 2,
  },
];

export const comment: FieldConfig[] = [
  {
    name: "comment",
    label: "Comments",
    type: "text",
    required: false,
    gridSpan: 4,
  },
];
